<script>
import baseMixin from '@/mixins/baseMixin'
import CandidateInfoCard from '@/components/candidate/candidate-info-card.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'DisputeDialogCandidateInfoCard',
  components: {
    CandidateInfoCard,
  },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      timesheet: 'disputes/activeTimesheet',
    }),
    compPhoneNumberList() {
      const phoneNumbers = [
        this.timesheet.candidate.phone1?.trim() || null,
        this.timesheet.candidate.phone2?.trim() || null,
        this.timesheet.candidate.phone3?.trim() || null,
      ]
      return phoneNumbers.filter((phoneNumber) => !!phoneNumber)
    },
  },
}
</script>

<template>
  <CandidateInfoCard
    :id="timesheet.candidate.id"
    :name="timesheet.candidate.name"
    :email="timesheet.candidate.email"
    :phone-numbers="compPhoneNumberList"
  />
</template>
